module.exports = __webpack_public_path__ + "static/media/UpTownSquare.9c3feac0.jpg";